export const bookProductName = 'Bücher'
